'use client';

import ChartHeader from './ChartHeader';
import SpectrogramViewer, { type SpectrogramPanel } from './SpectrogramViewer';
import Logo from '@/components/icons/Logo';

const panels: SpectrogramPanel[] = [
  { id: 'before', src: '/ring/ring-before.png', label: 'Before' },
  { id: 'after', src: '/ring/ring-after.png', label: 'After' },
];

const MAGMA =
  'linear-gradient(to top, #000004, #180f3e, #451077, #721f81, #9f2f7f, #cd4071, #f1605d, #fd9567, #feca8d, #fcfdbf)';

export default function A2Ring() {
  return (
    <div className="w-full border-y border-[#373739] py-4 sm:rounded-2xl sm:border sm:p-8">
      <ChartHeader
        title="Spectral Ring Artifacts"
        description="White noise bursts run through each model variant. Pay attention to the ringing artifact around 10 kHz."
      />
      <SpectrogramViewer
        title="STFT Magnitude Spectrograms"
        subtitle="Time (x-axis) vs frequency (y-axis); brighter means more energy at that moment"
        panels={panels}
        defaultView="before"
        aspectClass="aspect-[2628/1200]"
        freqMax={24000}
        colorbarGradient={MAGMA}
        colorbarMax={0.013}
        colorbarTicks={[0, 0.002, 0.004, 0.006, 0.008, 0.01, 0.012]}
      />
      <div className="mt-6 flex justify-end">
        <Logo style={{ height: 20, width: 'auto' }} />
      </div>
    </div>
  );
}
